define([
  'immutable',
  'es6!sumo/util',
  'es6!launcher/actions/SubscribersActions',
], (Immutable, Util, Actions) => {
  const initialState = Immutable.Map({
    error: '',
    importing: false,
    imports: Immutable.Map(),
    active: '',
  });

  const actionHandlers = {};

  actionHandlers[Actions.START_IMPORTING] = state => (
    state.merge({ importing: true, error: '' })
  );

  actionHandlers[Actions.ERROR_IMPORT] = (state, action) => (
    state.set('error', action.error)
  );

  actionHandlers[Actions.RECEIVE_IMPORT] = (state, action) => (
    state.mergeDeep({
      imports: {
        [action.id]: {
          state: (action.state || 'unmapped'),
          id: action.id,
          filename: action.filename,
          header: action.header,
          rows: action.rows,
        },
      },
      active: action.id,
      importing: true,
      error: '',
    })
  );

  actionHandlers[Actions.REMAP_IMPORT] = (state, action) => (
    state.merge({
      active: action.id,
      importing: true,
      error: '',
    })
  );

  actionHandlers[Actions.IMPORT_CANCELLATION] = (state, action) => {
    let newState = state;

    if (action.importId !== undefined) {
      const imports = state.get('imports');

      if (imports.size && imports.size > 0) {
        newState = newState.removeIn(['imports', action.importId]);
      }
    }

    return newState.merge({
      active: '',
      importing: false,
      error: '',
    });
  };

  actionHandlers[Actions.DISMISS_IMPORT] = (state, action) => (
    state.removeIn(['imports', action.importId])
  );

  actionHandlers[Actions.IMPORT_MAPPED] = (state, action) => {
    let newState = state;

    if (action.importId !== undefined) {
      const imports = state.get('imports');

      if (imports.size && imports.size > 0) {
        newState = newState.setIn(
          ['imports', action.importId, 'state'],
          'mapped',
        );
      }
    }

    return newState.merge({
      active: '',
      importing: false,
      error: '',
    });
  };

  actionHandlers[Actions.RECEIVE_IMPORTS] = (state, action) => (
    state.set('imports', action.imports)
  );

  return Util.createReducer(initialState, actionHandlers);
});
